<template>
    <div v-if="uploadInfo"
         :class="`media-library-progress-wrap ${!uploadInfo.hasFinishedUploading ? 'media-library-progress-wrap-loading' : ''} ${!uploadInfo.hasFinishedUploading && uploadInfo.uploadProgress === 100 ? 'media-library-progress-wrap-processing' : ''}`">
        <progress max="100" :value="uploadInfo.uploadProgress" class="media-library-progress"/>
    </div>

    <div class="media-library-thumb" dusk="thumb">
        <img
            v-if="!!imgProps.src && !imageErrored"
            v-bind="imgProps"
            class="media-library-thumb-img"
            @error="imageErrored = true"
        />

        <div v-else class="media-library-thumb-extension">
            <span class="media-library-thumb-extension-truncate">{{ imgProps.extension }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        uploadInfo: {required: true, type: Object},
        validationRules: {required: false, type: Object},
        imgProps: {required: true, type: Object},
    },
    emits: ['replaced'],
    data: function () {
        return {imageErrored: false, oldImgSrc: this.imgProps.src};
    },
    watch: {
        imgProps: {
            deep: true,
            immediate: true,
            handler: function (val) {
                if (this.oldImgSrc != val.src) {
                    this.imageErrored = false;
                }
            },
        },
    },
};
</script>
